"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionHeader = exports.MyInformationWrapper = exports.MissingAlert = exports.InfoItem = exports.ChangeMessage = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../CheckoutStep/styles");
const MyInformationWrapper = exports.MyInformationWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  ...(0, _styles.sectionStyles)(theme)
}));
const SectionHeader = exports.SectionHeader = (0, _mui.styled)('div')(({
  theme
}) => ({
  ...(0, _styles.sectionHeaderStyles)(),
  marginBottom: theme.spacing(4)
}));
const InfoItem = exports.InfoItem = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(1)
}));
const ChangeMessage = exports.ChangeMessage = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginTop: theme.spacing(3)
}));
const MissingAlert = exports.MissingAlert = (0, _mui.styled)(_mui.Alert)(({
  theme
}) => ({
  marginTop: theme.spacing(4)
}));